#import "../fragments/queued-email-fragment.graphql"

mutation RetryQueuedEmail($payload: EmailQueuedRetryInput!) {
    emailQueuedRetry(input: $payload) {
        emailSequence {
            emailsQueued {
                ...QueuedEmail
            }
        }
    }
}
